import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

/**
 * Fetch whether a user already has a referrer linked (admin).
 * @param {string} userId - the referee's user id (UUID)
 */
const GetRefereeStatus = (userId) => {
  return useQuery(
    ["get-referee-status", userId],
    () =>
      request({
        url: `/referral/admin/referee/${userId}`,
        method: "GET",
      }),
    {
      enabled: !!userId,
    }
  );
};

export default GetRefereeStatus;
